import axios from 'axios'
import querystring from 'querystring'

class TransportLayer {

  headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
  token = null
  baseUrl = null

  constructor(token, baseUrl) {
    this.token = token
    this.baseUrl = baseUrl
  }

  get(resource, params) {
    const url = this.getUrl(resource, this.clean(params))
    const headers = this.getHeaders()
    return axios.get(url, {headers})
  }

  post(resource, payload) {
    const url = this.getUrl(resource)
    const headers = this.getHeaders()
    return axios.post(url, this.encodePayload(payload), {headers})
  }

  patch(resource, payload) {
    const url = this.getUrl(resource)
    const headers = this.getHeaders()
    return axios.patch(url, this.encodePayload(payload), {headers})
  }

  delete(resource) {
    const url = this.getUrl(resource)
    const headers = this.getHeaders()
    return axios.delete(url, {headers})
  }

  encodePayload(payload) {
    //remove nullish values and encode de payload
    //https://stackoverflow.com/a/57625661/3017765
    this.clean(payload)
    return querystring.stringify(payload)
  }

  clean(payload) {
    for (let propName in payload) {
      if (payload[propName] === null || payload[propName] === undefined) {
        delete payload[propName];
      }
    }
    return payload
  }

  getHeaders() {
    if (this.token()) {
      this.headers.Authorization = `Bearer ${this.token()}`
    }
    return this.headers
  }

  getUrl(resource, params) {
    return `${this.baseUrl}${resource}${this.encode(params)}`
  }

  encode(params) {
    if (params) return `?${Object.keys(params).map((k) => this.encode_param(k, params[k])).join('&')}`
    return ''
  }
  encode_param(param, value){
    if (Array.isArray(value)){
      return value.map((v) => `${param}=${v}`).join('&')
    }
    return `${encodeURIComponent(param)}=${encodeURIComponent(value)}`
  }

}

export default TransportLayer
